<template>
  <section id="dashboard">
    <div
      v-if="loading"
      class="admin-loading-container"
    >
      <img src="@shared/assets/img/general/loading.svg">
    </div>
    <fragment v-else>
      <Navbar
        v-if="currentPage !== '/reset'
          && !currentPage.includes('/lead/')
          && currentPage !== '/expired-link'
          && currentPage !== '/expired-link/reset'
          && currentPage !== '/download/pro-app'
          && currentPage !== '/virtual-visit-instructions'
        "
      />
      <div :class="[!currentPage.includes('/lead/') ? 'd-container margin' : 'd-container']">
        <router-view />
      </div>
      <FooterComponent v-if="!currentPage.includes('/lead/')" />
    </fragment>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import Navbar from '@/components/navbar/Navbar.vue';
import FooterComponent from '@shared/components/Footer.vue';

export default {
  name: 'MainView',
  components: {
    Navbar,
    FooterComponent,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState({
      currentAdmin: state => state.admin.current,
    }),
    currentPage() {
      return this.$route.path;
    },
  },
  async mounted() {
    try {
      if (!this.currentAdmin.id) {
        await this.$store.dispatch('getCurrentAdminInfo');
      }
      this.$store.dispatch('getStatesData');
      this.$store.dispatch('getCountriesData');
      this.$store.dispatch('getProductsData');
      this.$store.dispatch('getAllProductsData');
      if (this.currentPage === '/') {
        this.$router.replace('/service');
      }
      this.loading = false;
    } catch (err) {
      if (localStorage.currentUser) {
        localStorage.removeItem('currentUser');
      }
      localStorage.redirectUrl = this.$route.path;
      this.$router.replace('/login').catch(() => { });
    }
  },
};
</script>

<style lang="scss">
section#dashboard {
  display: flex;
  flex-direction: column;
  flex: 1;

  .d-container {
    display: flex;
    flex: 1;

    &.margin {
      margin-top: 64px;
      margin-bottom: 28px;
    }
  }
}
</style>
